/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import TextEditor from "../../components/TextEditor";
import Header from "../../components/Header";
import Sidebar from "../../components/Sidebar";
import FeatherIcon from "feather-icons-react/build/FeatherIcon";
import { message } from "antd";
import { createEvent } from "../../services/eventService";
import { jwtDecode } from "jwt-decode";
import { fetchUserById } from "../../services/userService";

const AddEvent = () => {
  const navigate = useNavigate();

  // Form state
  const [title, setTitle] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [conductedBy, setConductedBy] = useState("");
  const [eventMode, setEventMode] = useState("");
  const [redirectUrl, setRedirectUrl] = useState("");
  const [eventTags, setEventTags] = useState("");
  const [metaTags, setMetaTags] = useState("");
  const [description, setDescription] = useState("");
  const [bannerImage, setBannerImage] = useState(null);
  const [thumbnailImage, setThumbnailImage] = useState(null);
  const [isFeatured, setIsFeatured] = useState(0);
  const [isSingleDay, setIsSingleDay] = useState(0);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [loggedInUserData, setLoggedInUserData] = useState(null);

  // Fetch logged-in user for logging
  React.useEffect(() => {
    const fetchAndSetUser = async () => {
      const token = localStorage.getItem("token");
      if (token) {
        try {
          const decoded = jwtDecode(token);
          const user = await fetchUserById(decoded.id);
          setLoggedInUserData(user);
        } catch (error) {
          console.error("Error decoding token or fetching user:", error);
        }
      }
    };
    fetchAndSetUser();
  }, []);

  const toggleFeatured = () => setIsFeatured(prev => prev ? 0 : 1);
  const toggleSingleDay = () => setIsSingleDay(prev => prev ? 0 : 1);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    // Log form submission attempt
    const logData = {
      action: 'EVENT_CREATE_ATTEMPT',
      user: loggedInUserData?.user_email || 'unknown',
      timestamp: new Date().toISOString(),
      data: {
        title,
        startDate,
        endDate,
        conductedBy,
        eventMode,
        isFeatured,
        isSingleDay
      }
    };

    // Create FormData object
    const formData = new FormData();

    // Append all fields with the exact names expected by the API
    formData.append("title", title);
    formData.append("content", description);
    formData.append("isFeatured", isFeatured);
    formData.append("isSingleDay", isSingleDay);
    formData.append("startDate", startDate);
    formData.append("endDate", endDate);
    formData.append("conductedBy", conductedBy);
    formData.append("mode", eventMode);
    formData.append("url", redirectUrl);
    formData.append("tags", eventTags);
    formData.append("metaTags", metaTags);

    // Append files with correct field names
    if (bannerImage) formData.append("event_image", bannerImage);
    if (thumbnailImage) formData.append("event_thumbnail", thumbnailImage);

    // Add user email for backend logging
    if (loggedInUserData?.user_email) {
      formData.append("addedbyemail", loggedInUserData.user_email);
    }

    try {
      const response = await createEvent(formData);
      
      // Log successful creation
      const successLog = {
        action: 'EVENT_CREATE_SUCCESS',
        user: loggedInUserData?.user_email || 'unknown',
        timestamp: new Date().toISOString(),
        eventId: response.eventId,
        title: title
      };

      message.success(response.message || "Event created successfully!");
      navigate("/list-events");
    } catch (error) {
      // Log creation failure
      const errorLog = {
        action: 'EVENT_CREATE_FAILED',
        user: loggedInUserData?.user_email || 'unknown',
        timestamp: new Date().toISOString(),
        error: error.message
      };

      message.error(
        error.message || "Failed to create event. Please try again."
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  // Log form field changes for important fields
  const handleTitleChange = (e) => {
    setTitle(e.target.value);
  };

  const handleFeaturedToggle = () => {
    const newValue = !isFeatured ? 1 : 0;
    setIsFeatured(newValue);
  };

  const handleSingleDayToggle = () => {
    const newValue = !isSingleDay ? 1 : 0;
    setIsSingleDay(newValue);
  };

  const handleBannerImageChange = (e) => {
    const file = e.target.files[0];
    setBannerImage(file);
  };

  const handleThumbnailImageChange = (e) => {
    const file = e.target.files[0];
    setThumbnailImage(file);
  };

  // Update the checkbox section in your JSX
  const checkboxSection = (
    <>
      <div className="col-6">
        <div className="form-check">
          <input
            type="checkbox"
            className="form-check-input"
            id="isFeatured"
            checked={!!isFeatured}
            onChange={handleFeaturedToggle}
          />
          <label className="form-check-label" htmlFor="isFeatured">
            Is Featured
          </label>
          <small className="d-block text-muted">
            Enabling this will make this event appear first
          </small>
        </div>
      </div>

      <div className="col-6">
        <div className="form-check">
          <input
            type="checkbox"
            className="form-check-input"
            id="isSingleDay"
            checked={!!isSingleDay}
            onChange={handleSingleDayToggle}
          />
          <label className="form-check-label" htmlFor="isSingleDay">
            Is Single Day Event
          </label>
          <small className="d-block text-muted">
            Enabling this will mark as single day
          </small>
        </div>
      </div>
    </>
  );

  // Update the submit button to show loading state
  const submitButton = (
    <button
      type="submit"
      className="btn btn-primary submit-form me-2"
      disabled={isSubmitting}
    >
      {isSubmitting ? "Publishing..." : "Publish Event"}
    </button>
  );

  const handleEditorChange = (valueOrEvent) => {
    setDescription(valueOrEvent?.target?.value || valueOrEvent);
  };

  return (
    <>
      <div className="main-wrapper">
        <Header />
        <Sidebar
          id="menu-item11"
          id1="menu-items11"
          activeClassName="add-blog"
        />

        <div className="page-wrapper">
          <div className="content">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="#">Events</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <FeatherIcon icon="chevron-right" />
                    </li>
                    <li className="breadcrumb-item active">Add Event</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-sm-12">
                <div className="card">
                  <div className="card-body">
                    <form onSubmit={handleSubmit} encType="multipart/form-data">
                      <div className="row">
                        <div className="col-12">
                          <div className="form-heading">
                            <h4>Event Details</h4>
                          </div>
                        </div>

                        <div className="col-12 col-md-6 col-xl-6">
                          <div className="form-group local-forms">
                            <label>
                              Event Title{" "}
                              <span className="login-danger">*</span>
                            </label>
                            <input
                              className="form-control"
                              type="text"
                              value={title}
                              onChange={handleTitleChange}
                              required
                            />
                          </div>
                        </div>

                        <div className="col-12 col-md-6 col-xl-6">
                          <div className="form-group local-forms">
                            <label>
                              Select Start Date{" "}
                              <span className="login-danger">*</span>
                            </label>
                            <input
                              className="form-control"
                              type="date"
                              value={startDate}
                              onChange={(e) => setStartDate(e.target.value)}
                              required
                            />
                          </div>
                        </div>

                        <div className="col-12 col-md-6 col-xl-6">
                          <div className="form-group local-forms">
                            <label>
                              Select End Date{" "}
                              <span className="login-danger">*</span>
                            </label>
                            <input
                              className="form-control"
                              type="date"
                              value={endDate}
                              onChange={(e) => setEndDate(e.target.value)}
                              required
                            />
                          </div>
                        </div>

                        <div className="col-12 col-md-6 col-xl-6">
                          <div className="form-group local-forms">
                            <label>
                              Conducted By{" "}
                              <span className="login-danger">*</span>
                            </label>
                            <input
                              className="form-control"
                              type="text"
                              value={conductedBy}
                              onChange={(e) => setConductedBy(e.target.value)}
                              required
                            />
                          </div>
                        </div>

                        <div className="col-12 col-md-6 col-xl-6">
                          <div className="form-group local-forms">
                            <label>
                              Select Event Mode{" "}
                              <span className="login-danger">*</span>
                            </label>
                            <select
                              className="form-control"
                              value={eventMode}
                              onChange={(e) => setEventMode(e.target.value)}
                              required
                            >
                              <option value="">Select Mode</option>
                              <option value="Online">Online</option>
                              <option value="Offline">Offline</option>
                              <option value="Hybrid">Hybrid</option>
                            </select>
                          </div>
                        </div>

                        <div className="col-12 col-md-6 col-xl-6">
                          <div className="form-group local-forms">
                            <label>Redirect URL</label>
                            <input
                              className="form-control"
                              type="text"
                              placeholder="https://example.com"
                              value={redirectUrl}
                              onChange={(e) => setRedirectUrl(e.target.value)}
                            />
                          </div>
                        </div>

                        <div className="col-12 col-md-6 col-xl-6">
                          <div className="form-group local-forms">
                            <label>
                              Event Tags <small>(comma separated)</small>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              value={eventTags}
                              onChange={(e) => setEventTags(e.target.value)}
                            />
                          </div>
                        </div>

                        <div className="col-12 col-md-6 col-xl-6">
                          <div className="form-group local-forms">
                            <label>
                              Meta Tags <small>(comma separated)</small>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              value={metaTags}
                              onChange={(e) => setMetaTags(e.target.value)}
                            />
                          </div>
                        </div>

                        {checkboxSection}

                        <div className="col-12 mt-3">
                          <div className="form-group summer-mail">
                            <TextEditor
                              value={description}
                              onChange={handleEditorChange}
                            />
                          </div>
                        </div>

                        <div className="col-12 col-md-6 col-xl-6">
                          <div className="form-group local-forms">
                            <label>
                              Select Event Banner Image{" "}
                              <span className="login-danger">*</span>
                            </label>
                            <div className="d-flex flex-column align-items-start">
                              <label htmlFor="banner" className="upload mb-2">
                                Choose File
                              </label>
                              <input
                                type="file"
                                accept="image/*"
                                id="banner"
                                onChange={handleBannerImageChange}
                                className="form-control"
                                required
                              />
                              {bannerImage && (
                                <small className="text-muted mt-1">
                                  {bannerImage.name}
                                </small>
                              )}
                            </div>
                          </div>
                        </div>

                        <div className="col-12 col-md-6 col-xl-6">
                          <div className="form-group local-forms">
                            <label>
                              Select Event Thumbnail Image{" "}
                              <span className="login-danger">*</span>
                            </label>
                            <div className="d-flex flex-column align-items-start">
                              <label
                                htmlFor="thumbnail"
                                className="upload mb-2"
                              >
                                Choose File
                              </label>
                              <input
                                type="file"
                                accept="image/*"
                                id="thumbnail"
                                onChange={handleThumbnailImageChange}
                                className="form-control"
                                required
                              />
                              {thumbnailImage && (
                                <small className="text-muted mt-1">
                                  {thumbnailImage.name}
                                </small>
                              )}
                            </div>
                          </div>
                        </div>

                        <div className="col-12">
                          <div className="doctor-submit text-end">
                            {submitButton}
                            <Link
                              to="/list-events"
                              className="btn btn-primary cancel-form"
                            >
                              Cancel
                            </Link>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="sidebar-overlay" data-reff="" />
    </>
  );
};

export default AddEvent;